export const DEVELOPER_EMAIL = "cjaystreamz@gmail.com";

export function isDeveloper(sessionOrUser) {
  const user = sessionOrUser?.user || sessionOrUser;
  return String(user?.email || "").trim().toLowerCase() === DEVELOPER_EMAIL;
}
